var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ChangeEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class SegmentedControlAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onChange = new ChangeEventListener();
    }
    /**
     * Returns the segmented control alignment.
     */
    getAlignment() {
        return this.state.alignment;
    }
    /**
     * Sets the segmented control alignment.
     *
     * @param alignment - The segmented control alignment.
     */
    setAlignment(alignment) {
        this.setState({ alignment });
    }
    /**
     * Returns if the segmented control is at least one item.
     */
    isAtLeastOne() {
        return this.state.atLeastOne;
    }
    /**
     * Sets if the segmented control is at least one item.
     *
     * @param atLeastOne - If the segmented control is at least one item.
     */
    setAtLeastOne(atLeastOne) {
        this.setState({ atLeastOne });
    }
    /**
     * Returns the segmented control data.
     */
    getData() {
        return this.state.data;
    }
    /**
     * Sets the segmented control data.
     *
     * @param data - The segmented control data.
     */
    setData(data) {
        this.setState({ data });
    }
    /**
     * Returns the segmented control direction on mobile.
     */
    getDirectionOnMobile() {
        return this.state.directionOnMobile;
    }
    /**
     * Sets the segmented control direction on mobile.
     *
     * @param directionOnMobile - The segmented control direction on mobile.
     */
    setDirectionOnMobile(directionOnMobile) {
        this.setState({ directionOnMobile });
    }
    /**
     * Returns if the segmented control is enabled.
     */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Sets if the segmented control is enabled.
     *
     * @param enabled - If the segmented control is enabled.
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    /**
     * Returns if the segmented control is expand to fill.
     */
    isExpandToFill() {
        return this.state.expandToFill;
    }
    /**
     * Sets if the segmented control is expand to fill.
     *
     * @param expandToFill - If the segmented control is expand to fill.
     */
    setExpandToFill(expandToFill) {
        this.setState({ expandToFill });
    }
    /**
     * Returns the segmented control item width.
     */
    getItemWidth() {
        return this.state.itemWidth;
    }
    /**
     * Sets the segmented control item width.
     *
     * @param itemWidth - The segmented control item width.
     */
    setItemWidth(itemWidth) {
        this.setState({ itemWidth });
    }
    /**
     * Returns if the segmented control is multi selection.
     */
    isMultiSelect() {
        return this.state.multiSelect;
    }
    /**
     * Sets if the segmented control is multi selection.
     *
     * @param itemWidth - If the segmented control is multi selection.
     */
    setMultiSelect(multiSelect) {
        this.setState({ multiSelect });
    }
    /**
     * Returns the segmented control theme.
     */
    getTheme() {
        return this.state.theme;
    }
    /**
     * Sets the segmented control theme.
     *
     * @param theme - The segmented control theme.
     */
    setTheme(theme) {
        this.setState({ theme });
    }
    /**
     * Returns the segmented control value.
     */
    getValue() {
        return this.state.value;
    }
    /**
     * Sets the segmented control value.
     *
     * @param value - The segmented control value.
     */
    setValue(value) {
        const { value: oldValue } = this.state;
        this.setState({ value });
        this.onChange.fire({ oldValue, value });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], SegmentedControlAPI.prototype, "onChange", void 0);
export { SegmentedControlAPI, };
//# sourceMappingURL=segmented-control-api.js.map